<template>
  <div id="MPLApp">
    <Header></Header>
    <MainMenu></MainMenu>
    <router-view id="MainContent" :key="$route.path"></router-view>
  </div>
</template>

<script>
import MainMenu from "./components/MainMenu";
import Header from "./components/Header";

export default {
  name: "App",
  components: { MainMenu, Header }
};
</script>

<style>
body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#MPLApp {
  width: 100vw;
  min-height: 100vh;
  text-align: justify;
  color: #2c3e50;
  display: grid;
  grid-template-areas: 
    "header header"
    "menu main";
  grid-template-columns:  1fr 6fr;
  grid-template-rows: 4rem auto;
  grid-column-gap: 1rem;
}
#NavList { grid-area: menu; }
#TopBar { grid-area: header; }
#MainContent { grid-area: main; padding: 3rem}

#MPLApp .shadowed {
  background: #fff;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
  border-radius: 6px;
  border: 1px solid rgba(10, 10, 10, 0.1);
}

#MPLApp .SubForm {
  display: block;
  width:80%;
  border: 1px solid #333;
  border-radius: 5px;
  padding: 0 1rem;
  margin: 0 auto 1rem;
}
#MPLApp .LockerImage {
    max-width: 200px;
    max-height: 200px;
    height: auto;
}
</style>